// @flow

import React, { type Node, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createStyleSheet } from 'jss-theme-reactor';
import classNames from 'classnames';

export type Props = {
  /**
   * Child nodes
   */
  children?: Node,
  className?: string
};

export const displayName = 'ModalSheet';

export const styleSheet = createStyleSheet(displayName, () => ({
  root: {
    fontSize: '16px'
  }
}));

export default class ModalSheet extends PureComponent<Props> {
  static displayName = displayName;

  static contextTypes = {
    styleManager: PropTypes.object.isRequired
  };

  render() {
    const { children, className } = this.props;
    const classes = this.context.styleManager.render(styleSheet);

    return (
      <div className={classNames(classes.root, className)}>{children}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/ModalSheet/ModalSheet.js